__turbopack_context__.v({
  "addressName": "_0NYqNa_addressName",
  "addressWrapper": "_0NYqNa_addressWrapper",
  "buttonsWrapper": "_0NYqNa_buttonsWrapper",
  "detailsWrapper": "_0NYqNa_detailsWrapper",
  "editButton": "_0NYqNa_editButton",
  "iconWrapper": "_0NYqNa_iconWrapper",
  "removeButton": "_0NYqNa_removeButton",
  "wrapper": "_0NYqNa_wrapper",
});
